import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'ui-bank-search-intro',
  styleUrl: 'ui-bank-search-intro.scss',
  shadow: false,
})
export class UiBankSearchIntro {
  render() {
    return (
      <Host>
        <ui-bank-search-intro-step icon="navigation" big>
          <h2 class="sd-headline sd-headline--size-lg primary">
            {(window as any).ui.services?.i18n?.translate('bankSearch')
              .findYourBank || 'Ihre Bank vor Ort finden'}
          </h2>
          <ui-bank-search-autocomplete></ui-bank-search-autocomplete>
          <ui-bank-search-intro-current-location></ui-bank-search-intro-current-location>
        </ui-bank-search-intro-step>
        <ui-bank-search-intro-step icon="letter">
          <p class="sd-headline sd-headline--size-base primary">
            {(window as any).ui.services?.i18n?.translate('bankSearch')
              .leaveContactDetails || 'Ihre Kontaktdaten hinterlassen'}
          </p>
        </ui-bank-search-intro-step>
        <ui-bank-search-intro-step icon="calendar">
          <p class="sd-headline sd-headline--size-base primary">
            {(window as any).ui.services?.i18n?.translate('bankSearch')
              .getMeetingProposals || 'Terminvorschlag von Ihrer Bank erhalten'}
          </p>
        </ui-bank-search-intro-step>
      </Host>
    );
  }
}
